import { useIdleTimer } from 'react-idle-timer';
import {
  ASSESSMENTS_INACTIVITY_TIMEOUT_WARNING_DURATION_MS,
  ASSESSMENTS_WARNING_TIMEOUT_MS,
} from '../constants';

interface UseTimeoutHookProps {
  onWarning: () => void;
  onAutoSave: () => void;
  onClose: () => void;
  inactivityTimeout?: number;
  warningTimeout?: number;
  disabled?: boolean;
}

export const useTimeoutHook = ({
  onWarning,
  onAutoSave,
  onClose,
  inactivityTimeout = ASSESSMENTS_INACTIVITY_TIMEOUT_WARNING_DURATION_MS,
  warningTimeout = ASSESSMENTS_WARNING_TIMEOUT_MS,
  disabled = false,
}: UseTimeoutHookProps) => {
  const { activate, reset } = useIdleTimer({
    timeout: inactivityTimeout + warningTimeout,
    promptBeforeIdle: warningTimeout,
    onPrompt: onWarning,
    onIdle: () => {
      onAutoSave();
      onClose();
    },
    disabled,
    crossTab: true,
    syncTimers: 200,
  });

  return {
    activateTimer: activate,
    resetTimer: reset,
  };
};
